(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    const translations = JSON.parse(drawer.querySelector('[data-drawer-translations]').textContent);
    const root = drawer.dataset.root.replace(/\/?$/, '/');
    const items = drawer.querySelector('[data-drawer-items]');
    const loading = drawer.querySelector('[data-drawer-loading]');
    const empty = drawer.querySelector('[data-drawer-empty]');
    const footer = drawer.querySelector('[data-drawer-footer]');
    const error = drawer.querySelector('[data-drawer-error]');
    let cart = null;
    let pending = false;
    let loadVersion = 0;
    let returnFocus = null;
    const escape = value => String(value ?? '').replace(/[&<>"']/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[character]);
    const money = cents => {
      const formatted = window.Shopify?.formatMoney(cents, drawer.dataset.moneyFormat);
      if (formatted) {
        const text = document.createElement('span');
        text.innerHTML = formatted;
        return escape(text.textContent);
      }
      return escape(new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cart?.currency || 'CAD' }).format(cents / 100));
    };
    function showError(message) {
      loading.hidden = true;
      error.hidden = false;
      drawer.querySelector('[data-drawer-error-text]').textContent = message;
    }
    function render(nextCart) {
      cart = nextCart;
      loadVersion++;
      loading.hidden = true;
      error.hidden = true;
      empty.hidden = cart.item_count > 0;
      footer.hidden = cart.item_count === 0;
      drawer.querySelector('[data-drawer-count]').textContent = `(${cart.item_count})`;
      drawer.querySelector('[data-drawer-subtotal]').innerHTML = money(cart.total_price);
      items.innerHTML = cart.items.map(item => {
        const key = escape(item.key);
        const title = escape(item.product_title);
        const image = item.featured_image?.url || item.image;
        const imageUrl = image ? new URL(image, window.location.origin) : null;
        if (imageUrl) imageUrl.searchParams.set('width', '176');
        const properties = Object.entries(item.properties || {}).filter(([name, value]) => !name.startsWith('_') && value).map(([name, value]) => `<p class="pnf-cart-drawer__variant">${escape(name)}: ${escape(value)}</p>`).join('');
        return `<article class="pnf-cart-drawer__item" data-key="${key}">
          <a class="pnf-cart-drawer__image" href="${escape(item.url)}" aria-label="${title}">${imageUrl ? `<img src="${escape(imageUrl.href)}" alt="${title}" width="88" height="116" loading="lazy">` : ''}</a>
          <div>
            <a class="pnf-cart-drawer__title" href="${escape(item.url)}">${title}</a>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="pnf-cart-drawer__variant">${escape(item.variant_title)}</p>` : ''}
            ${item.selling_plan_allocation ? `<p class="pnf-cart-drawer__variant">${escape(item.selling_plan_allocation.selling_plan.name)}</p>` : ''}
            ${properties}
            <p class="pnf-cart-drawer__price">${item.original_line_price > item.final_line_price ? `<s>${money(item.original_line_price)}</s>` : ''}${money(item.final_line_price)}</p>
            <div class="pnf-cart-drawer__controls">
              <div class="pnf-cart-drawer__quantity" role="group" aria-label="${escape(translations.quantity.replace('__PRODUCT__', item.product_title))}">
                <button type="button" data-quantity-change="-1" aria-label="${escape(translations.decrease)}">−</button>
                <output aria-live="polite">${item.quantity}</output>
                <button type="button" data-quantity-change="1" aria-label="${escape(translations.increase)}">+</button>
              </div>
              <button type="button" class="pnf-cart-drawer__remove" data-remove-item aria-label="${escape(translations.remove.replace('__PRODUCT__', item.product_title))}"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7M14 10v7"/></svg></button>
            </div>
          </div>
        </article>`;
      }).join('');
    }
    async function refresh() {
      const version = ++loadVersion;
      loading.hidden = Boolean(cart);
      error.hidden = true;
      try {
        const response = await fetch(root + 'cart.js', { credentials: 'same-origin' });
        if (!response.ok) throw new Error(translations.loadError);
        const nextCart = await response.json();
        if (version !== loadVersion) return;
        render(nextCart);
        window.Shopify?.onCartUpdate(nextCart, { openDrawer: false });
      } catch (failure) {
        if (version === loadVersion) showError(translations.loadError);
      }
    }
    function open(nextCart) {
      if (!drawer.open) {
        returnFocus = document.activeElement;
        drawer.showModal();
        document.documentElement.classList.add('pnf-cart-open');
      }
      if (nextCart?.items) render(nextCart);
      else refresh();
    }
    function close() { drawer.close(); }
    drawer.addEventListener('close', () => {
      document.documentElement.classList.remove('pnf-cart-open');
      if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
    });
    let backdropPointer = false;
    drawer.addEventListener('pointerdown', event => { backdropPointer = event.target === drawer; });
    drawer.addEventListener('click', event => {
      if (event.target === drawer && backdropPointer) close();
      if (event.target.closest('[data-close-cart]')) close();
      if (event.target.closest('[data-drawer-retry]')) refresh();
    });
    document.addEventListener('click', event => {
      if (!event.target.closest('[data-open-cart]') || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
      event.preventDefault();
      open();
    });
    items.addEventListener('click', async event => {
      const button = event.target.closest('[data-quantity-change], [data-remove-item]');
      if (!button || pending || !cart) return;
      const key = button.closest('[data-key]').dataset.key;
      const item = cart.items.find(line => line.key === key);
      if (!item) return;
      const isBogo = (window.pnfBogoVariantIds || []).some(id => String(id) === String(item.variant_id));
      const step = isBogo ? 2 : 1;
      const quantity = button.hasAttribute('data-remove-item') ? 0 : Math.max(0, item.quantity + Number(button.dataset.quantityChange) * step);
      const focusAttribute = button.hasAttribute('data-remove-item') ? '[data-remove-item]' : `[data-quantity-change="${button.dataset.quantityChange}"]`;
      pending = true;
      error.hidden = true;
      items.setAttribute('aria-busy', 'true');
      drawer.querySelectorAll('button[name="checkout"], [data-quantity-change], [data-remove-item]').forEach(control => { control.disabled = true; });
      try {
        const response = await fetch(root + 'cart/change.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : translations.updateError);
        render(result);
        window.Shopify?.onCartUpdate(result, { openDrawer: false });
        const updatedItem = Array.from(items.children).find(line => line.dataset.key === key);
        (updatedItem?.querySelector(focusAttribute) || items.querySelector('[data-quantity-change]') || drawer.querySelector('[data-close-cart]')).focus({ preventScroll: true });
      } catch (failure) {
        showError(failure.message || translations.updateError);
      } finally {
        pending = false;
        items.removeAttribute('aria-busy');
        drawer.querySelectorAll('button[name="checkout"], [data-quantity-change], [data-remove-item]').forEach(control => { control.disabled = false; });
      }
    });
    window.openCartDrawer = open;
    window.closeCartDrawer = close;
    window.refreshCartDrawer = nextCart => { if (nextCart?.items) render(nextCart); };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cookie-consent"] && !Shopify.designMode) return;
  try {
    (() => {
    const banner = document.querySelector('[data-cookie-consent]');
    const dialog = document.querySelector('[data-cookie-dialog]');
    if (!banner || !dialog) return;

    const inputs = {
      analytics: document.querySelector('[data-cookie-analytics]'),
      marketing: document.querySelector('[data-cookie-marketing]'),
      preferences: document.querySelector('[data-cookie-preferences]')
    };
    const controls = document.querySelectorAll('[data-cookie-consent] button, [data-cookie-dialog] button, [data-cookie-dialog] input');
    const statuses = document.querySelectorAll('[data-cookie-status]');
    let privacyPromise = null;
    let saving = false;

    function showStatus(message) {
      statuses.forEach(status => {
        status.textContent = message;
        status.hidden = !message;
      });
    }

    function setBusy(value) {
      saving = value;
      controls.forEach(control => { control.disabled = value; });
      banner.setAttribute('aria-busy', String(value));
      dialog.setAttribute('aria-busy', String(value));
    }

    function readyPrivacy() {
      const privacy = window.Shopify?.customerPrivacy;
      return privacy && ['setTrackingConsent', 'currentVisitorConsent', 'shouldShowBanner'].every(method => typeof privacy[method] === 'function') ? privacy : null;
    }

    function loadCustomerPrivacy() {
      const ready = readyPrivacy();
      if (ready) return Promise.resolve(ready);
      if (privacyPromise) return privacyPromise;

      privacyPromise = new Promise((resolve, reject) => {
        let finished = false;
        let retryTimer;
        const timeout = window.setTimeout(() => finish(new Error('Privacy API unavailable')), 6000);
        function finish(error) {
          if (finished) {
            const latePrivacy = readyPrivacy();
            if (!error && latePrivacy && !saving) {
              try {
                syncBanner(latePrivacy);
                showStatus('');
              } catch (failure) {
                showStatus(banner.dataset.errorMessage);
              }
            }
            return;
          }
          const privacy = readyPrivacy();
          if (!error && !privacy) error = new Error('Privacy API unavailable');
          finished = true;
          window.clearTimeout(timeout);
          window.clearTimeout(retryTimer);
          if (error) reject(error);
          else resolve(privacy);
        }
        function load() {
          if (finished) return;
          if (readyPrivacy()) return finish();
          if (typeof window.Shopify?.loadFeatures !== 'function') {
            retryTimer = window.setTimeout(load, 100);
            return;
          }
          try {
            window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => finish(error || null));
          } catch (error) {
            finish(error);
          }
        }
        load();
      }).catch(error => {
        privacyPromise = null;
        throw error;
      });
      return privacyPromise;
    }

    function syncBanner(privacy) {
      const consent = privacy.currentVisitorConsent();
      const hasChoice = Object.keys(inputs).every(key => consent[key] === 'yes' || consent[key] === 'no');
      banner.hidden = hasChoice || !privacy.shouldShowBanner();
    }

    function recordConsent(privacy, consent) {
      return new Promise((resolve, reject) => {
        let finished = false;
        const timeout = window.setTimeout(() => finish(new Error('Consent save timed out')), 6000);
        function finish(error) {
          if (finished) return;
          finished = true;
          window.clearTimeout(timeout);
          if (error) reject(error);
          else resolve();
        }
        try {
          privacy.setTrackingConsent(consent, result => {
            if (finished) return;
            try {
              if (result?.error) throw new Error('Consent save failed');
              const current = privacy.currentVisitorConsent();
              const confirmed = Object.keys(consent).every(key => current[key] === (consent[key] ? 'yes' : 'no'));
              finish(confirmed ? null : new Error('Consent was not confirmed'));
            } catch (error) {
              finish(error);
            }
          });
        } catch (error) {
          finish(error);
        }
      });
    }

    async function saveConsent(consent) {
      if (saving) return;
      setBusy(true);
      showStatus(banner.dataset.savingMessage);
      try {
        const privacy = await loadCustomerPrivacy();
        await recordConsent(privacy, consent);
        banner.hidden = true;
        if (dialog.open) dialog.close();
        showStatus('');
      } catch (error) {
        banner.hidden = false;
        showStatus(banner.dataset.errorMessage);
      } finally {
        setBusy(false);
      }
    }

    async function initialise() {
      try {
        const privacy = await loadCustomerPrivacy();
        if (!saving) syncBanner(privacy);
      } catch (error) {
        if (!saving) {
          banner.hidden = false;
          showStatus(banner.dataset.errorMessage);
        }
      }
    }

    document.querySelectorAll('[data-cookie-settings]').forEach(button => {
      button.addEventListener('click', async () => {
        if (saving) return;
        if (!dialog.open) dialog.showModal();
        showStatus('');
        const saveButton = document.querySelector('[data-cookie-save]');
        saveButton.disabled = true;
        Object.values(inputs).forEach(input => { input.disabled = true; });
        try {
          const privacy = await loadCustomerPrivacy();
          const consent = privacy.currentVisitorConsent();
          Object.keys(inputs).forEach(key => { inputs[key].checked = consent[key] === 'yes'; });
        } catch (error) {
          showStatus(banner.dataset.errorMessage);
        } finally {
          if (!saving) {
            saveButton.disabled = false;
            Object.values(inputs).forEach(input => { input.disabled = false; });
          }
        }
      });
    });
    document.querySelector('[data-cookie-accept]').addEventListener('click', () => saveConsent({ analytics: true, marketing: true, preferences: true }));
    document.querySelector('[data-cookie-reject]').addEventListener('click', () => saveConsent({ analytics: false, marketing: false, preferences: false }));
    document.querySelector('[data-cookie-save]').addEventListener('click', () => saveConsent({
      analytics: inputs.analytics.checked,
      marketing: inputs.marketing.checked,
      preferences: inputs.preferences.checked
    }));
    dialog.addEventListener('cancel', event => { if (saving) event.preventDefault(); });
    document.addEventListener('visitorConsentCollected', () => {
      const privacy = readyPrivacy();
      if (privacy && !saving) syncBanner(privacy);
    });
    window.addEventListener('pageshow', event => { if (event.persisted) initialise(); });
    initialise();
  })();
  } catch(e) { console.error(e); }
})();

})();
